@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";
@use "./tokens";

.container {
  flex-grow: 1;
  margin: 0 var(--mobile-gutter) var(--mobile-gutter);

  @include breakpoints.desktop {
    padding: 0 var(--desktop-gutter) var(--desktop-gutter);
    margin: 0 auto;
    max-width: calc(1240px + 2 * var(--desktop-gutter));
  }
}

.patientGreeting {
  font-family: typography.$font-serif;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--brand-indigo);
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 120%;
  margin-bottom: 10px;
  padding-top: 10px;
  margin-left: 20px;
  max-width: 100%;
  padding-right: 20px;
  
  @include breakpoints.desktop {
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0%;
    padding-top: 20px;
    max-width: 920px;
  }
}

.patientName {
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--brand-indigo);
  margin: 0;
  display: block;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 110%;
}

.columns {
  @include breakpoints.desktop {
    display: flex;
    flex-wrap: wrap;
    column-gap: 32px;
    margin-top: 20px;

    > * {
      flex-shrink: 1;
      flex-grow: 1;
    }

    > :first-child {
      flex-basis: 27em;
    }
  }
}

.recentPurchasesContainer {
  margin-top: 20px;
}

.logoutButton {
  margin: 0 var(--mobile-gutter);

  @include breakpoints.desktop {
    margin: 0 var(--desktop-gutter);
  }
}

.ctas {
  margin-top: 24px;
  text-align: center;
  margin-left: auto;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;

  @include breakpoints.desktop {
    text-align: left;
    margin-left: var(--mobile-gutter);
  }
}

.ctasBottom {
  margin-top: 0;
  text-align: center;
  margin-left: auto;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;

  @include breakpoints.desktop {
    text-align: left;
    margin-left: var(--mobile-gutter);
    font-size: 16px;
  }
}

.hideOnMobileWhenNoOrders {
  @media (max-width: 768px) {
    display: none;
  }
}

.hideOnDesktopWhenNoActivity {
  @include breakpoints.desktop {
    display: none;
  }
}

.footerCtas {
  margin-top: 8px;
  text-align: center;

  @include breakpoints.desktop {
    text-align: left;
    margin-left: var(--mobile-gutter);
  }
}

.footerCta {
  font-family: typography.$font-mont;
  font-weight: 400;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;

  @include breakpoints.desktop {
    font-size: 16px;
    text-align: left;
  }
}

.footerInlineLink {
  font-family: typography.$font-mont;
  font-weight: 700;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--brand-indigo);
  border: none;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-offset: 2px;

  @include breakpoints.desktop {
    font-size: 16px;
  }

  &:hover {
    border: none;
    color: var(--brand-indigo);
    text-decoration-line: underline;
  }
}

.mobileOnly {
  @include breakpoints.desktop {
    display: none;
  }
}

.inlineLink {
  font-family: typography.$font-mont;
  font-weight: 700;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--brand-indigo);
  border: none;
  text-decoration: underline;
  text-decoration-style: solid;
  text-underline-offset: 2px;

  @include breakpoints.desktop {
    font-size: 16px;
  }

  &:hover {
    border: none;
    color: var(--brand-indigo);
  }
}

.myAccount {
  justify-content: space-between;
}

.unfortunately {
  border-radius: 4px;
  background: var(--blue-03-alt);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);
  padding: 22px;
  color: var(--pure-black);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  a {
    color: var(--bright-blue);    
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
}
